import React, { useEffect } from 'react'
import useStore from '@/store'
import classNames from 'classnames'
import type { Props } from './types'
import CategoryBubbleContent from '../modal/category-bubble-content'
import { ReactComponent as HomeButton } from '@/assets/images/home-icon.svg'
import styles from './style.module.scss'

const MainControls: React.FC<Props> = ({ side }) => {
  const activeMode = useStore((state) => state.activeMode)
  const isIdle = useStore((state) => state.isIdle)
  const resetTableState = useStore((state) => state.resetTableState)
  const categoriesData = useStore((state) => state.categoriesData)
  const activeCategoryFilter = useStore((state) => state.activeCategoryFilter)
  const modals = useStore((state) => state.modals)
  const setModal = useStore((state) => state.setModal)
  const availableCategories = useStore((state) => state.availableCategories)
  const setActiveCategoryFilter = useStore(
    (state) => state.setActiveCategoryFilter
  )
  const sounds = useStore((state) => state.sounds)

  useEffect(() => {
    const category = categoriesData?.find(
      (c) => c.attributes.Slug === activeCategoryFilter[side]
    )

    if (modals[side]?.content) {
      if (
        modals[side]?.type === 'link-point' ||
        modals[side]?.type === 'resident'
      ) {
        return
      } else {
        setModal({ content: undefined, type: 'category' }, side)
        return
      }
    }

    category?.attributes.Accelerator &&
      setModal(
        {
          content: (
            <CategoryBubbleContent
              title={category?.attributes.Accelerator?.Title}
              subtitle={category?.attributes.Accelerator?.Subtitle}
              text={category?.attributes.Accelerator?.Text}
              color={category.attributes.Color}
              image={category.attributes.Accelerator.Image}
            />
          ),
          type: 'category',
          closeAction: () =>
            setModal({ content: undefined, type: 'category' }, side),
        },
        side
      )
    // eslint-disable-next-line
  }, [activeCategoryFilter[side]])

  const classes = classNames(
    styles['main-controls'],
    [styles[`side-${side}`]],
    { [styles['is-idle']]: isIdle }
  )
  const homeButtonClasses = classNames(styles['home-button'], {
    [styles['home-button--inactive']]:
      activeMode === 'basel' &&
      modals[side]?.content === undefined &&
      activeCategoryFilter[side] === undefined,
  })

  function onFilterClick(filter: string) {
    const category = categoriesData?.find((c) => c.attributes.Slug === filter)

    category?.attributes.Accelerator &&
    !modals[side]?.content &&
    activeCategoryFilter[side] !== filter
      ? sounds?.click2?.play()
      : sounds?.click1?.play()

    setActiveCategoryFilter(filter, side)
  }

  function onHomeButtonClick() {
    sounds?.click1?.play()
    resetTableState(side)
  }

  return (
    <div className={classes}>
      {categoriesData
        ?.sort((a, b) => (a.attributes.Order - b.attributes.Order ? 1 : -1))
        .map((category) => {
          const filterClasses = classNames(styles['categories-filter'], {
            [styles['is-inactive']]:
              activeCategoryFilter[side] &&
              activeCategoryFilter[side] !== category.attributes.Slug,
            [styles['is-unavailable']]:
              availableCategories &&
              !availableCategories.includes(category.attributes.Slug),
          })
          return (
            <button
              key={category.id}
              className={filterClasses}
              style={{ backgroundColor: category.attributes.Color }}
              onClick={() => onFilterClick(category.attributes.Slug)}
            >
              <span>{category.attributes.Title}</span>
            </button>
          )
        })}
      <button className={homeButtonClasses} onClick={() => onHomeButtonClick()}>
        <HomeButton />
      </button>
    </div>
  )
}

export default React.memo(MainControls)
